module.exports = __webpack_public_path__ + "static/laboheme4-cfa6fa2576217f52bd7a5a7e90be640b.jpg";